import { store, getContext } from '@wordpress/interactivity';

import { LOCAL_STORAGE_KEY } from '../poll/view-module.js';

const { state, callbacks } = store('mediapress-polls', {
  callbacks: {
    /**
     * Retrieves the user's votes from local storage.
     *
     * @return {Array} Array of votes from local storage
     */
    getLocalVotes: () => {
      const userVotes = localStorage.getItem(LOCAL_STORAGE_KEY);
      return JSON.parse(userVotes) || [];
    },
    /**
     * Calculates the number of correct answers and number of answered.
     */
    calculateCorrectAnswers() {
      const votes = callbacks.getLocalVotes();
      const context = getContext();
      const { correct, answered } = state.polls.reduce(
        (carry, poll) => {
          const vote = votes.find((v) => v.pollId === poll.pollId);

          if (vote && vote.optionId === poll.correctAnswer) {
            carry.correct += 1;
          }

          if (vote) {
            carry.answered += 1;
          }

          return carry;
        },
        { correct: 0, answered: 0 },
      );

      state.correctAnswers = correct;
      state.answered = answered;
      context.allAnswered = state.polls.length === state.answered;
    },
  },
});
